module.exports = __webpack_public_path__ + "media/images/svg/star-b19d10739acd009e436fb1d71f376f59.svg";